import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=aff56ea8&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&id=aff56ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff56ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aff56ea8')) {
      api.createRecord('aff56ea8', component.options)
    } else {
      api.reload('aff56ea8', component.options)
    }
    module.hot.accept("./Image.vue?vue&type=template&id=aff56ea8&scoped=true&", function () {
      api.rerender('aff56ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Image.vue"
export default component.exports